var React = require('react');

function CaretDownInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"data-name":"Path 247","d":"M.636.636l6.109 6.109L12.854.636","fill":"none","stroke":"#fff","strokeWidth":"1.8"}));
}

CaretDownInline.defaultProps = {"width":"13.491","height":"8.019"};

module.exports = CaretDownInline;

CaretDownInline.default = CaretDownInline;
